import { jsx as _jsx } from "react/jsx-runtime";
import { getEditableFloat, getFloat, getFormattedPrice, } from "@msys/formatting";
import { Euro as Euro } from "@mui/icons-material";
import { InputAdornment, TextField } from "@mui/material";
import React from "react";
import { useLocale } from "../LocaleProvider.js";
// TODO: extends FormattedInput
export function PriceInput({ value, onChange, min = Number.MIN_SAFE_INTEGER, max = Number.MAX_SAFE_INTEGER, showAdornment = false, InputProps, onFocus, onBlur, ...props }) {
    const locale = useLocale();
    const [isFocused, setIsFocused] = React.useState(false);
    const [dirtyValue, setDirtyValue] = React.useState(getEditableFloat(value ?? 0, locale));
    const floatFromDirty = getFloat(dirtyValue, locale);
    const isValid = floatFromDirty >= min && floatFromDirty <= max;
    function getValue(value) {
        if (isFocused || !isValid) {
            return dirtyValue;
        }
        return getFormattedPrice(value ?? 0, locale);
    }
    return (_jsx(TextField, { ...props, type: "text", value: getValue(value), onChange: async (event) => {
            setDirtyValue(event.target.value);
            const value = getFloat(event.target.value, locale);
            if (value >= min && value <= max) {
                onChange(value);
            }
        }, onFocus: event => {
            setIsFocused(true);
            if (isValid) {
                setDirtyValue(getEditableFloat(value ?? 0, locale));
            }
            onFocus?.(event);
        }, onBlur: event => {
            setIsFocused(false);
            onBlur?.(event);
        }, error: !isValid, slotProps: {
            input: {
                ...InputProps,
                endAdornment: showAdornment && (_jsx(InputAdornment, { position: "end", children: _jsx(Euro, {}) })),
            },
        } }));
}
//# sourceMappingURL=PriceInput.js.map